import React from "react";
import { GlassCard } from "../components/GlassCard";
import { TextInput, SelectInput } from "../components/NumberInput";
import { useBudget } from "../context/BudgetContext";
import { useI18n } from "../context/I18nContext";
import {
  SITUATION_FAMILIALE_OPTIONS,
  STATUT_LOGEMENT_OPTIONS,
  HORIZON_OPTIONS,
} from "../lib/constants";

export const ClientModule = () => {
  const { t } = useI18n();
  const { state, setClientField } = useBudget();
  const c = state.client;

  const situations = SITUATION_FAMILIALE_OPTIONS.map((v) => ({
    value: v,
    label: t.client.situations[v],
  }));
  const logements = STATUT_LOGEMENT_OPTIONS.map((v) => ({
    value: v,
    label: t.client.logements[v],
  }));
  const horizons = HORIZON_OPTIONS.map((v) => ({ value: v, label: t.client.horizons[v] }));

  return (
    <div className="flex flex-col gap-8" data-testid="module-client">
      <header className="flex flex-col gap-2">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
          {t.modules.client}
        </span>
        <h1 className="text-3xl sm:text-4xl tracking-tighter text-indigo-950" style={{ fontFamily: "Outfit, sans-serif" }}>
          {t.client.title}
        </h1>
        <p className="text-slate-500 text-base max-w-2xl">{t.client.subtitle}</p>
      </header>

      <GlassCard>
        <h2 className="text-lg font-medium text-indigo-950 mb-6" style={{ fontFamily: "Outfit, sans-serif" }}>
          {t.client.personal}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <TextInput testId="input-prenom" label={t.client.prenom} value={c.prenom} onChange={(v) => setClientField("prenom", v)} />
          <TextInput testId="input-nom" label={t.client.nom} value={c.nom} onChange={(v) => setClientField("nom", v)} />
          <TextInput testId="input-telephone" label={t.client.telephone} value={c.telephone} onChange={(v) => setClientField("telephone", v)} type="tel" />
          <TextInput testId="input-email" label={t.client.email} value={c.email} onChange={(v) => setClientField("email", v)} type="email" />
          <div className="md:col-span-2">
            <TextInput testId="input-adresse" label={t.client.adresse} value={c.adresse} onChange={(v) => setClientField("adresse", v)} />
          </div>
        </div>
      </GlassCard>

      <GlassCard>
        <h2 className="text-lg font-medium text-indigo-950 mb-6" style={{ fontFamily: "Outfit, sans-serif" }}>
          {t.client.family}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <SelectInput testId="select-situation" label={t.client.situationFamiliale} value={c.situationFamiliale} onChange={(v) => setClientField("situationFamiliale", v)} options={situations} />
          <TextInput testId="input-enfants" label={t.client.nombreEnfants} value={c.nombreEnfants} onChange={(v) => setClientField("nombreEnfants", v)} type="number" />
          <SelectInput testId="select-logement" label={t.client.statutLogement} value={c.statutLogement} onChange={(v) => setClientField("statutLogement", v)} options={logements} />
          <SelectInput testId="select-horizon" label={t.client.horizonPlacement} value={c.horizonPlacement} onChange={(v) => setClientField("horizonPlacement", v)} options={horizons} />
          <div className="md:col-span-2">
            <TextInput testId="input-objectif" label={t.client.objectifPatrimonial} value={c.objectifPatrimonial} onChange={(v) => setClientField("objectifPatrimonial", v)} />
          </div>
        </div>
      </GlassCard>
    </div>
  );
};
